import type { JSX } from 'react';
import { AvailabilityAlertsSubscriberAddForm } from '@/components/dashboard/availabilityAlerts/AvailabilityAlertsSubscriberAddForm';
import { AvailabilityAlertsSubscriberTable } from '@/components/dashboard/availabilityAlerts/AvailabilityAlertsSubscriberTable';

export function AvailabilityAlertsSubscribersPanel(): JSX.Element {
  return (
    <section className="rounded-2xl border border-surface-subtle bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-1">
        <p className="text-sm font-semibold text-brand-primary">Availability alert subscribers</p>
        <p className="text-xs text-text-primary/60">
          Email delivery is queued but sending is not enabled yet.
        </p>
      </div>

      <div className="mt-4 grid gap-4 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.65fr)] lg:items-start">
        <AvailabilityAlertsSubscriberAddForm />
        <AvailabilityAlertsSubscriberTable />
      </div>
    </section>
  );
}
